import moment from 'moment';
import * as types from './constants';

export const getDefaultDateFilter = () => ({
  since: moment.utc().startOf('day').format(),
  until: moment.utc().endOf('day').format(),
  type: 'last_days',
  number: 30
});

const parseDateMath = (since, until) => {
  if (!since) return null;
  if (since === 'now/M') return { type: 'this_month', since, until };
  if (since === 'now-1M/M') return { type: 'previous_month', since, until };
  // Backend may also represent previous_month as "now-29d/d" + "now/m" (case-insensitive)
  if (/^now-\d+d\/d$/i.test(since) && /^now\/m$/i.test(until || '')) return { type: 'previous_month', since, until };
  const lastDaysMatch = since.match(/^now-(\d+)d\/d$/i);
  if (lastDaysMatch) return { type: 'last_days', number: parseInt(lastDaysMatch[1], 10), since, until };
  // ISO dates (since_until) — strip dateMath suffixes if present
  return {
    type: 'since_until',
    since: since.replace('||/d', ''),
    until: (until || '').replace('||+1d/d', '')
  };
};

const initialState = {
  namePopup: false,
  dateFilter: getDefaultDateFilter(),
  data: {
    id: null,
    name: '',
    query_data: {
      min_filtered_active_links: null,
      max_filtered_active_links: null,
      min_filtered_clicks: null,
      max_filtered_clicks: null,
      min_filtered_gmv: null,
      max_filtered_gmv: null,

      first_active_link_date: null,
      last_active_link_date: null,
      first_commission_date: null,
      last_commission_date: null,
      connected_date: null
    }
  },
  unsavedChanges: false
};

const actions = {
  [types.SMART_GROUP_FLOW_SET_INIT]: (state, { payload }) => {
    const queryData = payload.query_data || {};
    const parsedDateFilter = parseDateMath(queryData.since, queryData.until);
    const dateFilter = parsedDateFilter || state.dateFilter;

    return {
      ...state,
      dateFilter,
      data: {
        ...state.data,
        id: payload.id ? payload.id : state.data.id,
        name: payload.name ? payload.name : state.data.name,
        query_data: {
          min_filtered_active_links: queryData.min_filtered_active_links ?? null,
          max_filtered_active_links: queryData.max_filtered_active_links ?? null,
          min_filtered_clicks: queryData.min_filtered_clicks ?? null,
          max_filtered_clicks: queryData.max_filtered_clicks ?? null,
          min_filtered_gmv: queryData.min_filtered_gmv ?? null,
          max_filtered_gmv: queryData.max_filtered_gmv ?? null,
          first_active_link_date: queryData.first_active_link_date ?? null,
          last_active_link_date: queryData.last_active_link_date ?? null,
          first_commission_date: queryData.first_commission_date ?? null,
          last_commission_date: queryData.last_commission_date ?? null,
          connected_date: queryData.connected_date ?? null
        }
      }
    };
  },

  [types.SMART_GROUP_FLOW_SET_PROP]: (state, { payload }) => {
    const data = {
      ...state,
      data: {
        ...state.data,
        [payload.prop]: payload.value
      },
      unsavedChanges: !payload.disableUnsavedChanges
    };

    return { ...data };
  },

  [types.SMART_GROUP_FLOW_SET_QUERY_DATA]: (state, { payload }) => ({
    ...state,
    data: {
      ...state.data,
      query_data: {
        ...state.data.query_data,
        ...payload
      }
    },
    unsavedChanges: true
  }),

  [types.SMART_GROUP_FLOW_SET_DATE_FILTER]: (state, { payload }) => ({
    ...state,
    dateFilter: payload,
    unsavedChanges: true
  }),

  [types.SMART_GROUP_FLOW_SET_UNSAVED_CHANGES]: (state, { payload }) => {
    const data = {
      ...state,
      unsavedChanges: payload
    };

    return { ...data };
  },

  [types.SMART_GROUP_FLOW_SET_NAME_POPUP]: (state, { payload }) => {
    const data = {
      ...state,
      namePopup: payload
    };

    return { ...data };
  },

  [types.SMART_GROUP_FLOW_CLEAR]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};